<script>
    let { children } = $props();
</script>

{#if children}
    <p class="text-muted-foreground text-sm">{@render children?.()}</p>
{/if}
